module.exports = __webpack_public_path__ + "static/media/pattern-4.f490447c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/pattern-4.png
// module id = 4832
// module chunks = 13